import { createActionTypes } from 'utils/action/actionTypes';

export const GET_DASHBOARD_V2_PERFORMANCE = createActionTypes('GET_DASHBOARD_V2_PERFORMANCE');
export const GET_DASHBOARD_V2_STATIONS = createActionTypes('GET_DASHBOARD_V2_STATIONS');
